import {DataTable, DataTableProps} from '@hconnect/uikit/src/lib2'
import {alpha, SxProps, Theme} from '@mui/material'
import {useMemo} from 'react'

interface PlannerDataTableProps<T> extends Omit<DataTableProps<T>, 'rowSx'> {
  rowSx?: (row: T) => SxProps<Theme>
  isRowSelected?: (row: T) => boolean
  isRowClickable?: (row: T) => boolean
}

/**
 * Wrapper for DataTable component.
 * Allows for selecting rows and hover effect.
 */
export const PlannerDataTable = <T,>({
  rowSx,
  isRowSelected,
  isRowClickable,
  ...dataTableProps
}: PlannerDataTableProps<T>) => {
  const defaultRowSx: SxProps<Theme> = useMemo(
    () => ({
      '&:hover': {
        backgroundColor: ({palette}) => alpha(palette.primary.light, 0.03)
      }
    }),
    []
  )

  return (
    <DataTable
      {...dataTableProps}
      rowSx={(row) => ({
        ...defaultRowSx,
        ...(isRowClickable?.(row) ? {cursor: 'pointer'} : {}),
        ...(isRowSelected?.(row)
          ? {backgroundColor: ({palette}) => alpha(palette.primary.light, 0.08)}
          : {}),
        ...(rowSx?.(row) ?? {})
      })}
    />
  )
}
